"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyles = void 0;

var tslib_1 = require("tslib");

var ui_helper_get_symbol_1 = require("@hopin-team/ui-helper-get-symbol");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = require("styled-components");

var makeBackgroundStyles = function makeBackgroundStyles(background, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_get_symbol_1.getColor)(background, theme));
};

var makeBorderStyles = function makeBorderStyles(border, theme) {
  var _a, _b;

  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n"], ["\n  border-width: ", ";\n  border-style: solid;\n  border-color: ", ";\n"])), (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.LINE) === null || _a === void 0 ? void 0 : _a.WIDTH) !== null && _b !== void 0 ? _b : ui_symbols_1.LINE.WIDTH, (0, ui_helper_get_symbol_1.getColor)(border, theme));
};

var Borders;

(function (Borders) {
  Borders["borderTop"] = "border-top";
  Borders["borderBottom"] = "border-bottom";
  Borders["borderRight"] = "border-right";
  Borders["borderLeft"] = "border-left";
})(Borders || (Borders = {}));

var removeBorderStyles = function removeBorderStyles(removeBorders) {
  var borderStyles = '';
  removeBorders.forEach(function (border) {
    borderStyles += "".concat(Borders[border], ": none;");
  });
  return borderStyles;
};

var makeRadiusStyles = function makeRadiusStyles(radius, theme) {
  return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  border-radius: ", ";\n"], ["\n  border-radius: ", ";\n"])), (0, ui_helper_get_symbol_1.getRadius)(radius, theme));
};

var makeLevelStyles = function makeLevelStyles(level, theme) {
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  box-shadow: ", ";\n"], ["\n  box-shadow: ", ";\n"])), (0, ui_helper_get_symbol_1.getShadow)(level, theme));
};

var isRelativeStyles = "\n  position: relative;\n";

var makeContainerStyles = function makeContainerStyles(container) {
  return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  max-width: ", "rem;\n  margin-left: auto;\n  margin-right: auto;\n  transition: padding-left ", " ", ",\n    padding-right ", " ", ";\n"], ["\n  max-width: ", "rem;\n  margin-left: auto;\n  margin-right: auto;\n  transition: padding-left ", " ", ",\n    padding-right ", " ", ";\n"])), container, ui_symbols_1.MOTION.BASE_DURATION, ui_symbols_1.MOTION.BASE_TIMING, ui_symbols_1.MOTION.BASE_DURATION, ui_symbols_1.MOTION.BASE_TIMING);
};

var makeContainerPadding = function makeContainerPadding(container, containerPadding) {
  return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  @media (max-width: ", "em) {\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"], ["\n  @media (max-width: ", "em) {\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"])), container, (0, ui_symbols_1.calcSpace)(containerPadding), (0, ui_symbols_1.calcSpace)(containerPadding));
};

exports.rootStyles = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'background', makeBackgroundStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'cornerRadius', makeRadiusStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'level', makeLevelStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'border', makeBorderStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isRelative', isRelativeStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'container', makeContainerStyles);
}, function (_a) {
  var container = _a.container,
      _b = _a.containerPadding,
      containerPadding = _b === void 0 ? 2 : _b;
  return container && makeContainerPadding(container, containerPadding);
}, function (props) {
  return props.border && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'removeBorders', removeBorderStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;